const DOCUMENT = 'DIVISION_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  EDIT: DOCUMENT + 'EDIT',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  ADD: DOCUMENT + 'ADD',
  CREATE: DOCUMENT + 'CREATE',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_MANAGERS_FORM_DATA: DOCUMENT + 'LOAD_MANAGERS_FORM_DATA',
  ADD_MANAGER_EDIT_PAGE: DOCUMENT + 'ADD_MANAGER_EDIT_PAGE',
  FILTER_UNITS: DOCUMENT + 'FILTER_UNITS',
  FILTER_UNITS_SUCCESS: DOCUMENT + 'FILTER_UNITS_SUCCESS',
  CHANGE_SELECTED_UNITS: DOCUMENT + 'CHANGE_SELECTED_UNITS',

  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveSuccess: () => ({ type: actions.SAVE_SUCCESS }),
  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),
  delete: data => ({ type: actions.DELETE, payload: data }),
  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),
  add: data => ({ type: actions.ADD, payload: data }),
  create: data => ({ type: actions.CREATE, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  changeProperties: data => ({ type: actions.CHANGE_PROPERTIES, payload: data }),
  changeUnitProperty: data => ({ type: actions.CHANGE_UNIT_PROPERTY, payload: data }),
  cancel: () => ({ type: actions.CANCEL }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  loadManagersFormData: data => ({ type: actions.LOAD_MANAGERS_FORM_DATA, payload: data }),
  addManagerOnEditPage: data => ({ type: actions.ADD_MANAGER_EDIT_PAGE, payload: data }),
  filterUnits: data => ({ type: actions.FILTER_UNITS, payload: data }),
  filterUnitsSuccess: data => ({ type: actions.FILTER_UNITS_SUCCESS, payload: data }),
  changeSelectedUnits: data => ({ type: actions.CHANGE_SELECTED_UNITS, payload: data }),
};

export default actions;
